// 重定向中间件
export default defineNuxtRouteMiddleware((to) => {
  const { isBrHost } = useJudgeBrHost()
  if (!isBrHost.value && to.path.startsWith('/pt')) {
    return navigateTo(to.path.replace('/pt', '/en'))
  }
})
